// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`SelectOption test Match con el snapshot 1`] = `<option value=""></option>`;
